import { render } from "./SessionDetail.vue?vue&type=template&id=4faed50a&scoped=true"
import script from "./SessionDetail.vue?vue&type=script&lang=js"
export * from "./SessionDetail.vue?vue&type=script&lang=js"

import "./SessionDetail.vue?vue&type=style&index=0&id=4faed50a&scoped=true&lang=css"

import exportComponent from "C:\\BiggerInside\\Protocol223-Portal\\portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4faed50a"]])

export default __exports__